import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpResponseHandleHelper } from '@zero/shared/util-services';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CLEVER_PUSH_ENVIRONMENT_CONFIG } from '../config/clever-push.config';
import { CleverPushSubscriptionRequest, CleverPushTopic, CleverPushTopicRequest } from '../entities/clever-push.entity';

@Injectable({
  providedIn: 'root',
})
export class CleverPushInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #config = inject(CLEVER_PUSH_ENVIRONMENT_CONFIG);
  readonly #endpoint = `${environment.apihost + this.#config.notificationServiceUrl}/push`;

  public getOAuthToken(): Observable<{ token: string }> {
    const url = `${environment.serverlessApihost}${environment.oAuth2Endpoints.token}`;
    return this.#http.get<{ token: string }>(url);
  }

  public postSubscription(config: Omit<CleverPushSubscriptionRequest, 'platform'>): Observable<boolean> {
    const { subscriptionId } = config;
    const url = `${this.#endpoint}/subscription`;

    const body = {
      subscriptionId,
      platform: this.#config.platform,
    };

    return this.#http.post<boolean>(url, body, { params: HttpResponseHandleHelper.skipGlobalHandler() });
  }

  public deleteSubscriptionById(config: { subscriptionId: string }): Observable<boolean> {
    const { subscriptionId } = config;
    const url = `${this.#endpoint}/subscription/${subscriptionId}`;

    return this.#http.delete<boolean>(url);
  }

  public getTopics(): Observable<CleverPushTopic[]> {
    const url = `${this.#endpoint}/topics/${this.#config.platform}`;
    return this.#http.get<CleverPushTopic[]>(url);
  }

  public putTopic(config: Omit<CleverPushTopicRequest, 'platform'>): Observable<boolean> {
    const url = `${this.#endpoint}/topics`;

    return this.#http.put<boolean>(url, [
      {
        ...config,
        platform: this.#config.platform,
      },
    ]);
  }
}
